<template>
  <span>{{ genderReadable }}</span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({ gender: null });

const genderReadable = computed(() => {
  switch (props.gender) {
    case "H":
      return "Herr";
      break;
    case "F":
      return "Frau";
      break;
    case "D":
      return "Divers";
      break;

    default:
      return "Unbekannt";
      break;
  }
});
</script>
